var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowRight33(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "8px",
    viewBox: "0 0 6.0 8.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.606565415,0 C0.741213595,0.00322147671 0.870373051,0.0540474459 0.971071168,0.14349052 L4.95729687,3.55739802 C5.08398509,3.66551187 5.15694959,3.82370042 5.15694959,3.99024923 C5.15694959,4.15679805 5.08398509,4.3149866 4.95729687,4.42310045 L0.971071168,7.83367468 C0.819936928,7.98453999 0.597058865,8.0380892 0.393883018,7.97235129 C0.19070717,7.90661339 0.0414393719,7.73265571 0.00732364373,7.52185245 C-0.0267920844,7.31104918 0.0599878386,7.09889029 0.232057934,6.97242378 L3.71375435,3.99080836 L0.232057934,1.0080962 C0.0450136055,0.853880226 -0.023792192,0.598095597 0.0606401001,0.3708527 C0.145072392,0.143609803 0.364202607,-0.0051919552 0.606565415,0.000138662132 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-165.0 -514.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.0 85.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 402.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.00000000000046 23.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.22044605e-16,0 5.15694959,0 5.15694959,8 2.22044605e-16,8 2.22044605e-16,0",
    stroke: "none",
    fill: "#333333"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight33);
export default __webpack_public_path__ + "static/media/icArrowRight33.d928ff52f5c729c0be2f95616f820c04.svg";
export { ForwardRef as ReactComponent };